if (!customElements.get('hero-product-slider')) {
  class HeroProductSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero__product-slide'));
      if (!this.slides.length) return;

      this.track = this.querySelector('.hero__product-slides');
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');

      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.timer = null;

      this.prevBtn?.addEventListener('click', () => this.go(this.index - 1, true));
      this.nextBtn?.addEventListener('click', () => this.go(this.index + 1, true));

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      this.setupSwipe();

      if (this.slides.length > 1 && this.autoplay) this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    go(nextIndex, manual) {
      const total = this.slides.length;
      if (!total) return;
      this.index = ((nextIndex % total) + total) % total;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
        }
      });
      if (manual && this.autoplay) this.startAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      if (this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    setupSwipe() {
      if (!this.track) return;
      let startX = 0;
      let tracking = false;
      this.track.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
        tracking = true;
      }, { passive: true });
      this.track.addEventListener('touchend', (event) => {
        if (!tracking) return;
        tracking = false;
        const deltaX = event.changedTouches[0].clientX - startX;
        if (Math.abs(deltaX) < 40) return;
        this.go(this.index + (deltaX < 0 ? 1 : -1), true);
      }, { passive: true });
    }
  }
  customElements.define('hero-product-slider', HeroProductSlider);
}
